import { useEffect } from 'react';
import clsx from 'clsx';

/**
 * App-shell sidebar: static column from `md` up, off-canvas drawer below it.
 * `invisible` while closed keeps the hidden drawer's links out of the tab
 * order; transitioning visibility lets the slide-out finish before it hides.
 * Following any link inside closes the drawer so the new page is visible.
 */
export default function ResponsiveSidebar({ open, onClose, className, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      {open && (
        <button
          type="button"
          aria-label="Close menu"
          className="fixed inset-0 z-40 cursor-default bg-black/40 animate-fade-in md:hidden"
          onClick={onClose}
        />
      )}
      <aside
        onClick={(e) => e.target.closest('a') && onClose?.()}
        className={clsx(
          'fixed inset-y-0 left-0 z-40 flex flex-col transition-[transform,visibility] duration-200',
          'md:visible md:static md:z-auto md:translate-x-0 md:shadow-none',
          open ? 'visible translate-x-0 shadow-xl' : 'invisible -translate-x-full',
          className,
        )}
      >
        {children}
      </aside>
    </>
  );
}
